const TVIcon = (props) => {
  return (
    <svg
      width="16px"
      height="16px"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <path d="m0 0h32v32h-32z" />

        <path
          d="m25.2763114 3 .6840403 1.87938524-5.8283517 2.12061476h11.868v22h-32v-22h11.828l-5.828-2.12061476.68404029-1.87938524 9.29895971 3.382zm4.7236886 6h-28v18h28zm-14 4c2.7614237 0 5 2.2385763 5 5s-2.2385763 5-5 5-5-2.2385763-5-5 2.2385763-5 5-5zm0 2c-1.6568542 0-3 1.3431458-3 3s1.3431458 3 3 3 3-1.3431458 3-3-1.3431458-3-3-3z"
          fill="#000000"
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
};

export default TVIcon;
